import React from 'react';

/** "Showing X of Y" footer with a Load more button for incrementally paged grids. */
export const LoadMoreBar: React.FC<{
  shown: number;
  total: number;
  loading: boolean;
  onLoadMore: () => void;
}> = ({ shown, total, loading, onLoadMore }) => {
  if (total === 0) return null;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        marginTop: 16,
        fontSize: 12,
        color: 'var(--text-secondary)',
      }}
    >
      <span>
        Showing {shown} of {total}
      </span>
      {shown < total && (
        <button className="eval-btn-secondary" onClick={onLoadMore} disabled={loading}>
          {loading ? 'Loading…' : 'Load more'}
        </button>
      )}
    </div>
  );
};
